export default function Wordmark({ size = "lg", darkBg = true }) {
  const sizes = {
    sm: "text-2xl",
    lg: "text-5xl md:text-6xl",
    xl: "text-7xl",
  };

  return (
    <span className={`font-black tracking-tight ${sizes[size]}`}>
      <span className="text-[#FF0000]">You</span>
      <span className={darkBg ? "text-white" : "text-[#0F0F0F]"}>Sift</span>
    </span>
  );
}
